import { Map } from 'immutable';

type State = Map<string, number>;
// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
export const initialState: State = new Map();

/*
 * A store that keeps track of the read marker push events.
 * This store should be be relied upon to know if a message was read or not!
 * This store exist to override stream items read summary state
 *
 */
export default function reducer(state: State = initialState, action: any): State {
  switch (action.type) {
    case 'changeset-update-chat_marker':
      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'change' implicitly has an 'any' type.
      action.changes.forEach((change) => {
        state = state.set(change.uuid, change.content.markers.read_seq);
      });

      return state;
    default:
      return state;
  }
}
